module.exports = __webpack_public_path__ + "img/questionnaire-icon.9e15c0a5.svg";